import React , { useState, useEffect, useRef } from "react";

import styles from "./currentNews.module.css";
// import AppBar from "../../components/appBar/appBar";
import ImgBuilder from "../../assets/ImgBuilder";
import AbortGame from "../../components/abortGame/abortGame";

import { getHeadline, saveTraceStep } from "../../api/api";
import { useUserData } from '../../functions/updateUserData';
import { useLanguage } from '../../functions/setGetLanguage';
import { renderWithLineBreaksAndBold } from '../../functions/renderWithLineBreaksAndBold';
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const CurrentNews = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { userData, setUserData } = useUserData();
  const { language } = useLanguage();
  const [currentFeedback, setCurrentFeedback] = useState(null);
  const headlineRef = useRef(false);


  useEffect(() => {
    if (headlineRef.current) return;

    const fetchTopicNews = async () => {
      headlineRef.current = true;
      try {
        const headlineData = await getHeadline(userData.topic_id, userData.tokens["access_token"], language.substring(1));
        setUserData(prev => {
          // Start building the new headlineData
          let newTraceSteps = headlineData.trace_steps;

          if (headlineData.start !== 1 && headlineData?.rethinking) {
            // fill previous steps with random answers for rethinking
            const randomAnswer = () => (Math.random() < 0.5 ? "reliable" : "shady");
            newTraceSteps = newTraceSteps.map(step =>
              step.step_num < headlineData.start
                ? { ...step, answer: randomAnswer() }
                : step
            );
          }

          return {
            ...prev,
            headlineData: {
              ...headlineData,
              finishedTrace: false,
              trace_steps: newTraceSteps
            },
            activeStep: headlineData.start
          };
        }); 
      } catch (error) {
        console.error("Failed to fetch headline:", error);
      } 
    };

    if (!userData.headlineData || userData?.headlineData?.finishedTrace) {
      fetchTopicNews();
    }
  }, [userData.topic_id, userData.tokens, userData.headlineData, language, setUserData]);
  

  const handleAnswer = async (answer) => {
    try {
      // save the answer
      const traceStep = {
        language: language.substring(1), // cause it is saved as "_en" or "_de", or "_es"
        trace_id: +userData.headlineData.trace_id,
        step_num: userData.activeStep,
        answer: answer,
        mode: currentFeedback ? "feedback" : "original"
      };
      setUserData(prev => {
        const steps = prev.headlineData.trace_steps.map(step =>
          step.step_num === prev.activeStep
            ? { ...step, answer } // update only the matching step - ideally would be if key was such
            : step
        );
        return {
          ...prev,
          headlineData: {
            ...prev.headlineData,
            trace_steps: steps  // <-- just replace the array
          }
        };
      });
      await saveTraceStep(userData.tokens.access_token, traceStep);
      // navigation
    } catch (err) {
      console.error("Error: ",err);
    } finally{
      // Next step or end the game currently with 
      // always going to "confirmation" rethinking page
      const nextStep = userData.activeStep + 1;
      if (userData.headlineData?.trace_steps[userData.activeStep-1]?.feedback && !currentFeedback){
        // show feedback
        // TODO: fix this activeStep logic.
        setCurrentFeedback(userData.headlineData.trace_steps[userData.activeStep-1].feedback)
      }
      else{
        setCurrentFeedback(null)
        if (nextStep > userData.headlineData.trace_steps.length){
          setUserData(prev => ({
            ...prev,
            headlineData: {
              ...prev.headlineData,
              finishedTrace: true // explicitly add it here - might be relic and nt required
            },
            activeStep: prev.headlineData.start
          }));
          if (userData.headlineData.rethinking){
            navigate('/rethinking')
          } else{
            navigate('/statistics')
          }
        } 
        else{
          setUserData(prev => ({
            ...prev,
            activeStep: nextStep 
          })); 
        }
      }
    }
      
    
  };

  return (
    <div className={styles.wrapper}>
      <img alt="bg" className={styles.bgImg} src={ImgBuilder.sbBackground}/>

      <div className={styles.contentCenter}>
      {/* <AppBar /> */}
      <AbortGame />
      {userData?.headlineData?.trace_steps && 
      <div className={styles.headerExplanation}>
        <div className={styles.headerTop}>{t("news_page.topic")} {t(`news_page.topics.${userData.topic_id}`)}</div>
        <div className={styles.headerMain}>{renderWithLineBreaksAndBold(t("news_page.description"))}</div>
        
      </div>
      }
      
      {userData?.headlineData?.trace_steps && 
      <div className={styles.warpperAllHeadlines}>

        <div className={`${styles.notificationHeadline} ${currentFeedback ? styles.notificationHeadlineActive: ""}`}>
          <div className={styles.upperPartNotification}>
          </div>
          <div className={styles.mainPartNotification}>
            {currentFeedback}

            <p className={styles.popupMainPartNotification}>
              {t("news_page.notification_call_crowd")}
            </p>
          </div>
        </div>

        <div className={styles.headlinePaper}>
          <img src={ImgBuilder.headline_blank} alt='headline' className={styles.headlinePicturePaper} />
          <div className={styles.headlineTextPaperContainter}>
            <p className={styles.headlineTextPaper}>{userData.headlineData.trace_steps[(userData.activeStep-1)].text}</p>
          </div>
        </div>
        
      </div>
      }
      

      
        </div>
        <div className={styles.footerButtons}>

        <div onClick={() => handleAnswer("reliable")} className={`${styles.squareButton} ${styles.reliable}`}>
          <div className={styles.buttonText}>
            {t("news_page.reliable")}
          </div>
        </div>

        <div onClick={() => handleAnswer("shady")} className={styles.squareButton}>
          <div className={styles.buttonText}>
            {t("news_page.shady")}
          </div>
        </div>
        
      </div>

        <div className={styles.wrapperHeadlinesHead}>
        {userData?.headlineData?.trace_steps && 
        Array.from({ length: userData.headlineData.trace_steps.length }, (_, i) => (i+1)).map((num, index, arr) => (
          <React.Fragment key={num}>
            <div
              className={`${styles.waypointHead} ${num === userData.activeStep ? styles.wayReached : ""}`}
            >
              {num}
            </div>
            {index < arr.length - 1 && <div className={styles.waypointLine}></div>}
          </React.Fragment>
        ))}
        </div>
    </div>
  );
};

export default CurrentNews;
